<template>
  <div>
    <v-row align="center" justify="start">
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          v-model="dealClientName"
          :items="dealsClients"
          item-text="clientName"
          item-value="clientName"
          label="Client"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          v-model="consultantName"
          :items="dealsConsultants"
          item-text="consultantName"
          item-value="consultantName"
          label="Consultant"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          v-model="jobTitle"
          :items="dealsJobTitles"
          item-text="jobTitle"
          item-value="jobTitle"
          label="Job Title"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          :items="[{id: 1, type: 'Contract'}, {id: 2, type: 'Contract to Hire'}, {id: 3, type: 'Perm. Placement'}]"
          item-value="id"
          item-text="type"
          v-model="dealAssignmentType"
          label="Type"
          :clearable="true"
          outlined
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <DealStatusesDropDownList
          :id="statusId"
          @change="handleDealStatusChange"
        ></DealStatusesDropDownList>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl="2" class="py-0 my-0">
        <v-autocomplete
          v-model="createdBy"
          :items="dealsCreatedBy"
          item-text="createdByName"
          item-value="id"
          label="Created By"
          outlined
          clearable
        ></v-autocomplete>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6">
        <FilterButtons
          @search="handleSearchClick"
          @clear="handleClearClick"
        ></FilterButtons>
      </v-col>
    </v-row>
    <FilterButtonsSmall
      @search="handleSearchClick"
      @clear="handleClearClick"
    ></FilterButtonsSmall>
  </div>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { mapActions } from 'vuex'
import { FilterButtons, FilterButtonsSmall } from '@/components/buttons'
import { BySalesUserDropDownList } from '@/components/users'
import { DealStatusesDropDownList } from '@/components/dealStatuses'
import { DEAL_ASSIGNMENT_TYPES } from '@/lib/constants/dealAssignmentTypes'

export default {
  components: {
    BySalesUserDropDownList,
    DealStatusesDropDownList,
    FilterButtons,
    FilterButtonsSmall
  },
  data () {
    return {
      DEAL_ASSIGNMENT_TYPES
    }
  },
  props: [
    'dealsClients',
    'dealsConsultants',
    'dealsJobTitles',
    'dealsCreatedBy'
  ],
  computed: {
    ...mapFields('dealFilters', [
      'dealClientName',
      'consultantName',
      'jobTitle',
      'dealAssignmentType',
      'createdBy',
      'statusId'
    ])
  },
  methods: {
    ...mapActions('dealFilters', [
      'clearFilters'
    ]),
    handleSearchClick () {
      this.$emit('search')
    },
    handleCretedByChange (value) {
      this.createdBy = value
    },
    handleUpdatedByChange (value) {
      this.updatedBy = value
    },
    handleDealStatusChange (value) {
      this.statusId = value
    },
    handleClearClick () {
      this.clearFilters()
      this.$emit('clear')
    }
  }
}
</script>
